import { render, staticRenderFns } from "./dashboardComponent.vue?vue&type=template&id=dedd6c48&scoped=true&"
import script from "./dashboardComponent.vue?vue&type=script&lang=js&"
export * from "./dashboardComponent.vue?vue&type=script&lang=js&"
import style0 from "./dashboardComponent.vue?vue&type=style&index=0&id=dedd6c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedd6c48",
  null
  
)

export default component.exports